import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const ISearchFilter = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
          <line x1="1" y1="2.07812" x2="17" y2="2.07812" stroke="#37474F" strokeWidth="2" strokeLinecap="round"/>
          <line x1="1" y1="15.9219" x2="17" y2="15.9219" stroke="#37474F" strokeWidth="2" strokeLinecap="round"/>
          <line x1="1" y1="9" x2="17" y2="9" stroke="#37474F" strokeWidth="2" strokeLinecap="round"/>
          <circle cx="6" cy="2" r="1.5" fill="white" stroke="#37474F"/>
          <circle cx="6" cy="16" r="1.5" fill="white" stroke="#37474F"/>
          <circle cx="13" cy="9" r="1.5" fill="white" stroke="#37474F"/>
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default ISearchFilter;
